<template>
  <div id="organizations">
    <!-- Organizations Filter -->
    <b-form-input
      type="text"
      ref="filterOrganizations"
      placeholder="Filter Organizations"
      v-model="filter">
    </b-form-input>
    <!-- / Organizations Filter -->

    <!-- Organizations Table -->
    <b-table
      striped
      hover
      selectable
      small
      show-empty
      select-mode="single"
      sort-by="name"
      @row-selected="goToOrganization"
      :items="filteredOrganizations"
      :fields="fields"
      empty-text="No Organizations to show.">
    </b-table>
    <!-- / Organizations Table -->

    <!-- Create Organizations Button -->
    <b-button
      class="corner-button shadow"
      type="button"
      variant="success"
      @click="$router.push({ name: 'organization', params: { organizationID: 'new' } })">
      <font-awesome-icon icon="plus"></font-awesome-icon> Create New Organization
    </b-button>
    <!-- / Create Organizations Button -->
  </div>
</template>

<script>
import _ from 'lodash';
import AppMixin from '../services/app-mixin';

export default {
  name: 'organizations',
  mixins: [
    AppMixin,
  ],
  data() {
    return {
      filter: '',
      fields: [
        {
          key: 'name',
          label: 'Organization',
          sortable: true,
        },
      ],
    };
  },
  computed: {
    filteredOrganizations() {
      return _.filter(
        this.organizations,
        o => o.name.toLowerCase().includes(this.filter.toLowerCase()),
      );
    },
  },
  methods: {
    goToOrganization(selected) {
      const [o] = selected;
      this.$router.push({
        name: 'organization',
        params: { organizationID: o.id },
      });
    },
  },
  created() {
    this.showGlobalLoader('Loading organizations...');
    this.initPromise.finally(this.hideGlobalLoader);
  },
};
</script>

<style lang="scss"></style>
